
import React, { useEffect, useState } from "react";
import Input from "components/Elements/Input";
import ErrorField from "components/ErrorField";
import { FormToggle, FormSubLabel, FormElement, FormLabel, FormInput } from "components/StyledElements";
import { getAbbreviatedTimeZone, fromDateToString, getLocalDateFromString } from "../../../utils/utils";


export const CoreDetails = ({ emailCampaign, onChange = () => { }, style = {} }) => {
  const [formErrors, setFormErrors] = useState({});
  const [localScheduledTime, setLocalScheduledTime] = useState("");

  useEffect(() => {
    setFormErrors({});
    setLocalScheduledTime(
      emailCampaign?.scheduled_time
        ? fromDateToString(getLocalDateFromString(emailCampaign.scheduled_time), false)
        : ""
    );

    // eslint-disable-next-line
  }, [emailCampaign]);


  const handleChange = ({ target }) => {
    const a = { ...emailCampaign };
    a[target.name] = target.value;
    onChange(a);
  };

  const handleDateChange = (name, value) => {
    const a = { ...emailCampaign };
    a[name] = value;
    onChange(a);
  };

  return (
    <div style={{ flexDirection: "column", ...style }}>
      <FormElement style={{ flexDirection: "column", display: "flex", gap: "10px" }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
          <FormLabel label={`Active (${emailCampaign?.active ? "Yes" : "No"})`} style={{ margin: 0 }} />
          <FormToggle
            checked={emailCampaign?.active ?? false}
            onChange={(e) => {
              emailCampaign.active = e.target.checked;
              onChange({ ...emailCampaign });
            }}
          />
        </div>
        <FormSubLabel label="Active email campaigns will be sent to recipients when the campaign is active. This can be manually enabled, or it can start at a scheduled time" />
      </FormElement>
      <label>ID</label>
      <Input
        label="ID"
        placeholder="ID"
        name="id"
        value={emailCampaign && emailCampaign.id ? emailCampaign.id : ""}
        disabled
      />
      <label>Public ID</label>
      <Input
        label="Public ID"
        placeholder="Public ID"
        name="public_id"
        value={
          emailCampaign && emailCampaign.public_id
            ? emailCampaign.public_id
            : ""
        }
        disabled
      />
      <FormElement>
        <FormLabel label={<div>From Email <ErrorField>{formErrors.from_email}</ErrorField></div>} />
        <FormInput placeholder="From Email" name="from_email" value={emailCampaign && emailCampaign.from_email ? emailCampaign.from_email : ""} onChange={handleChange} />
      </FormElement>
      <FormElement>
        <FormLabel label={<div>Title <ErrorField>{formErrors.title}</ErrorField></div>} />
        <FormInput placeholder="Title" name="title" value={emailCampaign && emailCampaign.title ? emailCampaign.title : ""} onChange={handleChange} />
      </FormElement>
      <FormElement>
        <FormLabel label={`Scheduled Time (${getAbbreviatedTimeZone()}) - When the event is open for questions`} />
        <FormInput type="datetime-local"
          value={localScheduledTime}
          onBlur={(e) => {
            // Close the date picker
            e.target.blur();
          }}
          onChange={(e) => {
            const newDate = new Date(e.target.value);
            const utcString = newDate.toISOString().substr(0, 16);

            handleDateChange("scheduled_time", utcString);
          }}
        />

      </FormElement>
      <FormElement>
        <FormLabel label={<div>Description <ErrorField>{formErrors.description}</ErrorField></div>} />
        <FormInput as="textarea" placeholder="Description" name="description" value={emailCampaign && emailCampaign.description ? emailCampaign.description : ""} onChange={handleChange} />
      </FormElement>
      <FormElement>
        <FormLabel label="Subject" />
        <FormInput placeholder="Subject" name="subject" value={emailCampaign && emailCampaign.subject ? emailCampaign.subject : ""} onChange={handleChange} />
      </FormElement>
      <FormElement>
        <FormLabel label="Body" />
        <FormInput as="textarea" placeholder="Body" name="body" value={emailCampaign && emailCampaign.body ? emailCampaign.body : ""} onChange={handleChange} style={{ height: "250px" }} />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
